var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      { staticClass: "table table-hover table-sm" },
      _vm._l(_vm.users, function (user, id, index) {
        return _c("tr", [
          _c("td", { attrs: { width: "50px" } }, [
            _vm._v(_vm._s((index === undefined ? id : index) + 1)),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              [
                _vm.editUser
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-info pull-left mr-2",
                        on: {
                          click: function ($event) {
                            return _vm.editUser(user)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("UserInfo", { attrs: { user: user } }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "td",
            _vm._l(user.roles, function (role) {
              return _c("p", [_vm._v(_vm._s(role.name_title))])
            }),
            0
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }